import './styles/index.scss';

import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { QueryClientProvider } from '@tanstack/react-query';
import { store } from 'redux/store';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { I18nextProvider } from 'react-i18next';
import { CssBaseline, ThemeProvider } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';

import App from './App';
import ScrollToTop from 'ScrollToTop';

import reportWebVitals from './reportWebVitals';
import UserProvider from './contexts/UserProvider';
import './internationalization/i18n';
import i18n from './internationalization/i18n';
import appThemeV1 from './theme/themeV1';
import { queryClient } from 'queryClient';
import {
    applyDomainFavicon,
    applyDomainPaletteCssVars,
    syncPreviewThemeFromQuery,
} from 'utils/domainBranding';

syncPreviewThemeFromQuery();
applyDomainFavicon();
applyDomainPaletteCssVars();

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
    <React.StrictMode>
        <Provider store={store}>
            <QueryClientProvider client={queryClient}>
                <ThemeProvider theme={appThemeV1}>
                    <CssBaseline />
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <I18nextProvider i18n={i18n}>
                            <BrowserRouter future={{ v7_startTransition: true }}>
                                <ScrollToTop />
                                <UserProvider>
                                    <Routes>
                                        <Route path="/*" element={<App />} />
                                    </Routes>
                                </UserProvider>
                            </BrowserRouter>
                        </I18nextProvider>
                    </LocalizationProvider>
                </ThemeProvider>
            </QueryClientProvider>
        </Provider>
    </React.StrictMode>
);

reportWebVitals();
